import { displayDateFormatWithDay } from '@/constants/dates';
import { Box, Grid, Text } from '@cmpsr/components';
import { format } from 'date-fns';
import useTestingPlanController from '../your-testing-plan/your-testing-plan.controller';
import DashboardLayout from '@/components/dashboard/dashboard-layout/dashboard-layout';
import HeaderBackground from '@/components/ui/header-background/header-background';

export default function TestingPlanHeader() {
  const { planStartDate, planEndDate } = useTestingPlanController();

  return (
    <DashboardLayout
      containerProps={{
        position: 'relative',
        overflow: 'hidden',
      }}
      contentProps={{ as: 'header', gap: 5 }}
    >
      <HeaderBackground blur={30} />
      <Box position="relative" zIndex={1} display="flex" flexDirection="column" gap={5}>
        <Text variant="text-body-meta-medium" textTransform="uppercase" color="tan">
          {format(new Date(planStartDate), displayDateFormatWithDay)} -{' '}
          {format(new Date(planEndDate), displayDateFormatWithDay)}
        </Text>

        <Grid gridTemplateColumns={{ base: 'auto', lg: '1fr 400px' }} gap={{ base: 8, lg: 8, xl: 9, xxl: 12 }}>
          <Box>
            <Text as="h1" variant="text-header-4XL" mb={2} data-testid="testing-plan-header-text" color="tan">
              Your Testing{' '}
              <Text as="span" textStyle="text-header-4xl-v" color="tan">
                Plan
              </Text>
            </Text>
            <Text variant="text-body-regular" fontSize={{ base: '14px', lg: '16px' }} color="tan">
              Your Annual Testing Plan represents the optimal screening tests to conduct over the next 12 months based on
              your current risk across all major cancers.
            </Text>
          </Box>
        </Grid>
      </Box>
    </DashboardLayout>
  );
}
